// The sidebar's pages in display order, each with the key that shows it.
// The sidebar draws from this list, and the landing page after sign-in uses it to find the first page a user may open.
export const NAV = [
  { section: 'Main', items: [
    { id: 'dashboard',  label: 'Dashboard',  icon: 'ti-layout-dashboard', perm: 'dashboard.view' },
    { id: 'students',   label: 'Students',   icon: 'ti-users',             perm: 'students.view' },
    { id: 'families',   label: 'Families',   icon: 'ti-home',              perm: 'families.view' },
    { id: 'attendance', label: 'Attendance', icon: 'ti-calendar-check',    perm: 'attendance.view' },
    { id: 'complaints', label: 'Complaints', icon: 'ti-message-circle-2',  perm: 'complaints.view' },
    { id: 'affairs',    label: 'Student Affairs', icon: 'ti-heart-handshake', perm: 'behavior.view' },
  ]},
  { section: 'Finance', items: [
    { id: 'fees',       label: 'Fees',       icon: 'ti-receipt',       badge: true, perm: 'fees.view' },
    { id: 'pos',        label: 'POS',        icon: 'ti-shopping-cart',              perm: 'pos.view' },
    { id: 'inventory',  label: 'Inventory',  icon: 'ti-package',                    perm: 'inventory.view' },
    { id: 'finance',    label: 'Finance',    icon: 'ti-report-money',               perm: 'expenses.view' },
  ]},
  { section: 'Academic', items: [
    { id: 'exams',      label: 'Exams',      icon: 'ti-writing',          perm: 'exams.view' },
    { id: 'timetable',  label: 'Timetable',  icon: 'ti-calendar-time',    perm: 'timetable.view' },
    { id: 'diary',      label: 'Diary',      icon: 'ti-notebook',         perm: 'diary.view' },
    { id: 'staff',      label: 'Staff',      icon: 'ti-id-badge',         perm: 'staff.view' },
    { id: 'reports',    label: 'Reports',    icon: 'ti-chart-bar',        perm: 'reports.view' },
    { id: 'documents',  label: 'Documents',  icon: 'ti-file-certificate', perm: 'documents.view' },
  ]},
  { section: 'System', items: [
    { id: 'settings',   label: 'Settings',   icon: 'ti-settings',         perm: 'settings.view' },
  ]},
];
